<template>
  <div class="bg-white py-md-2 py-2 px-md-4 position-relative mb-3">
    <div class="content-wrapper  px-3">
      <div class="d-flex align-items-center mb-2">
        <router-link class="pointer h5 m-0" :to="`/system/satisfaction-survey/list`">
          <b-icon icon="arrow-left" class="mr-2" />
        </router-link>
        <section>
          <span class="d-block text-muted">Questionário</span>
          <h5 class="m-0">{{ current_form.name }}</h5>
        </section>
      </div>
      <hr />
      <div
        class="mt-3 d-flex w-100 justify-content-between align-items-center mb-2"
      >
        <p class="text-muted mb-0">{{ current_form.description }}</p>
        <div class="d-flex align-items-center gap-3">
          <b-button size="sm" variant="light" @click="handleEditForm">
            Editar
          </b-button>
          <b-button size="sm" variant="danger" @click="handleOpenConfirmDelte">
            Excluir
          </b-button>
        </div>
      </div>
    </div>
    <b-modal
      id="edit-form-questions"
      centered
      hide-footer
      size="md"
      no-close-on-backdrop
      :title="`Formulário de pesquisa`"
    >
      <FormEdit :id="formId" :isAdd="false" @submited="handleCloseModal" />
    </b-modal>
    <b-modal id="delete-form-question" centered size="sm">
      <template #modal-header> <h5>Atenção!</h5></template>
      <p>
        Você apagará o questionário <strong>{{ current_form.name }}</strong
        >, deseja continuar?
      </p>
      <template #modal-footer="{ close }">
        <b-button variant="link" @click="handleDeleteForm()">
          Sim
        </b-button>
        <b-button variant="primary" @click="close()">Não</b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import FormEdit from "./FormEdit.vue";

export default {
  components: {
    FormEdit,
  },

  data() {
    return {
      formId: "",
    };
  },
  computed: {
    ...mapGetters(["current_form", "is_mobile"]),
  },
  methods: {
    ...mapActions(["hide_application_header", "get_form", "delete_form"]),
    handleOpenConfirmDelte() {
      this.$bvModal.show("delete-form-question");
    },

    handleEditForm() {
      this.$bvModal.show("edit-form-questions");
    },
    handleCloseModal() {
      this.$bvModal.hide("edit-form-questions");
    },
    handleDeleteForm() {
      this.delete_form(this.formId).then(() => {
        this.$bvModal.hide("delete-form-question");
        this.$router.push("/system/satisfaction-survey/list");
      });
    },
  },

  beforeDestroy() {
    this.hide_application_header(true);
  },
  mounted() {
    this.formId = this.$route.params.id;
    this.hide_application_header(false);
  },
};
</script>
